module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/error-404.28e87a3b.svg";